export const paymentWithdrawAllSelector = (state) =>
  state?.paymentWithdrawReducer?.paymentWithdrawAll;
export const paymentWithdrawBanksSelector = (state) =>
  state?.paymentWithdrawReducer?.paymentWithdrawBanks;
export const paymentWithdrawCodeSelector = (state) =>
  state?.paymentWithdrawReducer?.paymentWithdrawCode;
export const paymentWithdrawSearchSelector = (state) =>
  state?.paymentWithdrawReducer?.paymentWithdrawSearch;
export const paymentWithdrawLastSelector = (state) =>
  state?.paymentWithdrawReducer?.paymentWithdrawLast;
